const categories = [
    {
      name: "Anti-analgesic",
      icon: "/images/anti_analgesic.png",
      description: "Medications used to relieve pain without causing loss of consciousness."
    },
    {
      name: "Anti-biotics",
      icon: "/images/anti_biotics.png",
      description: "Drugs that fight bacterial infections by killing or inhibiting bacterial growth."
    },
    {
      name: "Cardiac & Diabetic",
      icon: "/images/cardiac_diabetic.png",
      description: "Treatments and supplements designed for heart conditions and diabetes management."
    },
    {
      name: "Anti-ulcerants & Anti-nauserants",
      icon: "/images/anti_ulcerants_nauserants.png",
      description: "Medicines used to treat stomach ulcers and relieve nausea or vomiting."
    },
    {
      name: "Anti-oxidents / Multivitamin & Multi mineral",
      icon: "/images/anti_oxidants_multivitamins.png",
      description: "Supplements to boost immunity and fill dietary nutritional gaps."
    },
    {
      name: "Expectorant / Cough Syrup",
      icon: "/images/expectorant_cough_syrup.png",
      description: "Syrups and formulations to relieve cough and clear respiratory congestion."
    },
    {
      name: "Anti cold / Anti Pyratics",
      icon: "/images/anti_cold_pyratics.png",
      description: "Medications that reduce fever and relieve cold and flu symptoms."
    },
  ];
  
  export default categories;
  